<template>
    <div class="templete_box">
        <div class="templete no_print">
            <div class="search_box search_box_f no_print clearfix">
                <el-select class="search_select search_inputBox" v-model="params.warehouse_id" filterable placeholder="仓库" @visible-change="getSelectWarehouseList('warehouse_id')">
                    <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.opening_company_id" filterable placeholder="货权单位" @visible-change="getSelectWarehouseList('opening_company_id')">
                    <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <!-- <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div> -->
                    <!-- v-if="module.indexOf(',warehouse-statistic-export,')!=-1" -->
                    <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="financeFliterBox clearfix">
                <div class="financeTitle">自定义财务报表设置:</div>
                <div class="financeFliterC clearfix">
                    <div v-for="item in filterJson" :key="item.key" :class="['financeFliter',item.isChecked?'financeFliterChecked':'']" @click="filterClick(item)">{{item.name}}</div>
                </div>
            </div>
            <div class="tableTitle">财务报表{{title}}</div>
            <div class="tableBox">
                <tabletem :isShowIndex="true" :isHideColumn="false" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">入库方数：{{ statistics.month_in_storage_cube }}m³</div>
                <div class="totalNumber">入库金额：{{ statistics.month_in_storage_amount }}</div>
                <div class="totalNumber">出库方数：{{ statistics.month_out_storage_cube }}m³</div>
                <div class="totalNumber">出库金额：{{ statistics.month_out_storage_amount }}</div>
                <div class="totalNumber">销售方数：{{ statistics.month_sales_cube }}m³</div>
                <div class="totalNumber">销售金额：{{ statistics.month_sales_amount }}</div>
                <div class="totalNumber">退货方数：{{ statistics.month_return_cube }}m³</div>
                <div class="totalNumber">退货金额：{{ statistics.month_return_amount }}</div>
                <!-- <div class="totalNumber">营业支出：{{ statistics.business_fee }}</div> -->
                <div class="totalNumber">销售毛利：{{ statistics.sales_margin }}</div>

            </div>
            <div class="pagination_path">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- <filter-fields :tableData="filter" :scene="'inventory.out.column'" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields> -->
    </div>
</template>
<style scoped>
    .tableTitle{font-size: 16px;width: 100%;text-align: center;padding:5px 0;font-weight: 600;}
    .financeFliterBox{padding:10px 10px 0 10px;}
    .financeTitle{float: left;line-height: 36px;font-size: 15px;}
    .financeFliterC{float: left;}
    .financeFliter{float: left;min-width: 75px;font-size: 14px; height: 32px;line-height: 29px;text-align: center;padding: 0 12px;border-radius: 3px;border: 1px solid #666666;cursor: pointer;margin:0 6px;}
    .financeFliterChecked{border: 1px solid #b21111;position: relative;color: #B21111;}
    .financeFliterChecked:after{display: block;content: "";width: 21px;height: 21px;position: absolute;right: 0;bottom: 0;background: url(/icon/checkeded.png) no-repeat;background-size: cover;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            tabletem,
            pagination,
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleOut:false,
                filterDialogVisible:false,
                filter:"",
                companyName:localStorage.dw_erp_company_name,
                list:[],
                tableCol:[
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"上月结余方数",colKey:"last_month_balance_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"上月结余金额",colKey:"last_month_balance_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月入库方数",colKey:"month_in_storage_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月入库金额",colKey:"month_in_storage_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月出库方数",colKey:"month_out_storage_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月出库金额",colKey:"month_out_storage_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月销售方数",colKey:"month_sales_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月销售金额",colKey:"month_sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月退货方数",colKey:"month_return_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月退货金额",colKey:"month_return_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月结余方数",colKey:"month_balance_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"本月结余金额",colKey:"month_balance_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"本月营业支出",colKey:"business_fee",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"毛利",colKey:"sales_margin",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                filterJson:[
                    {key:"bale_no",name:"捆包号",isChecked:true},
                    {key:"breed",name:"品名",isChecked:true},
                    {key:"brand",name:"品牌",isChecked:true},
                    {key:"grade",name:"等级",isChecked:true},
                    {key:"thickness",name:"厚度",isChecked:true},
                    {key:"length",name:"长度",isChecked:true},
                    {key:"warehouse",name:"仓库",isChecked:true},
                    {key:"opening_company",name:"货权单位",isChecked:true},
                ],
                statistics:{
                    month_in_storage_cube:"",
                    month_in_storage_amount:"",
                    month_out_storage_cube:"",
                    month_out_storage_amount:"",
                    month_sales_cube:"",
                    month_sales_amount:"",
                    business_fe:"",
                    sales_margin:""
                },
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    attribute_id:[],
                    color_id:[],
                    opening_company_id:[]
                },
                report_id:"",
                title:"",
                params:{
                    report_id:"",
                    warehouse_id:"",
                    opening_company_id:"",
                    group:[],
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                current_page:1
            }
        },
        created() {
            if(sessionStorage.DEMU_ERP_FINANCEMONTH_ID){
                this.report_id=sessionStorage.DEMU_ERP_FINANCEMONTH_ID;
                this.params.report_id=sessionStorage.DEMU_ERP_FINANCEMONTH_ID;
                this.getList();
                sessionStorage.removeItem("DEMU_ERP_FINANCEMONTH_ID")
            }
        },
        methods:{
            filterClick(row){
                row.isChecked = !row.isChecked;
                this.tableCol.forEach(item=>{
                    if(item.colKey == row.key){
                        item.isShow = row.isChecked;
                    }
                })
                this.getList(true)
            },
            exportExcelBill(){
                this.params.report_id = this.report_id;
                this.$exportExecl("/erp/finance.month.report.export","财务明细详情",this.params)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.params.group = [];
                this.getList(true);
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            filterConfirm(){
                this.getBillColumn()
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.report_id = this.report_id;
                // let arr = new Array();
                this.params.group = [];
                this.filterJson.forEach(item=>{
                    if(item.isChecked){
                        this.params.group.push(item.key)
                    }
                })

                this.tableLoading = true;
                this.postFunc("/erp/finance.month.report.detail",this.params,response=>{
                    if(response.data.code == 0){
                        this.list = response.data.data.list.data;
                        this.total = response.data.data.list.total;
                        this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.list.last_page;
                        this.title = response.data.data.title;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                        // let boxHeight = document.getElementById("tableTempleteBox").offsetHeight ? document.getElementById("tableTempleteBox").offsetHeight : document.getElementById("elTable").offsetHeight;
                        // document.getElementById("tableTempleteBox").getElementsByClassName("el-table__body-wrapper")[0].style.cssText = (boxHeight - 37)+"px;";
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList(true);
            }
        }
    }
</script>
